import React, { useRef } from 'react'
import SignatureCanvas from 'react-signature-canvas'
import * as ReactBootstrap from 'react-bootstrap'
import { ICONS } from './common'

export const SignaturePad = ({ width, height, onEnd }) => {
  const ref = useRef()
  const clear = () => {
    ref.current.clear()
  }
  return (
    <>
      <ReactBootstrap.Col xs={12} className={'text-end'}>
        <ReactBootstrap.Button variant={'danger'} onClick={() => clear()} block>
          {ICONS.DELETE}
        </ReactBootstrap.Button>
      </ReactBootstrap.Col>
      <SignatureCanvas
        dotSize="5"
        onEnd={() => onEnd(ref.current.getTrimmedCanvas().toDataURL())}
        ref={ref}
        canvasProps={{ width: width, height: height }}
      />
    </>
  )
}
